<template>
  <section class="sec-1">
    <img
      class="sec-1__honey-bee-3 sec-1__honey-bee"
      src="../../public/image/honeyBee-2.webp"
    />
    <img
      class="sec-1__honey-bee-4 sec-1__honey-bee"
      src="../../public/image/honeyBee-2.webp"
    />
    <div class="why-we">
      <div class="why-we__part1" ref="whyWePart1">
        <div class="why-we__images" :class="{ active: showHexagon }">
          <div class="why-color why-color-1"></div>
          <div class="why-color why-color-2"></div>
          <div class="why-color why-color-3"></div>
          <div class="why-image why-image-1"></div>
          <div class="why-image why-image-2"></div>
          <div class="why-image why-image-3"></div>
        </div>
      </div>

      <div class="why-we__part2" ref="whyWePart2">
        <div class="why-we__text">
          <h2 class="why-we__title">{{ titleText }}</h2>
          <p class="why-we__parag" :class="{ active: showWhyWeText }">
            {{ paraText }}
          </p>
          <div class="why-we__btns" :class="{ active: showWhyWeText }">
            <router-link class="base-btn-2 why-we__btn" to="/contactUs"
              ><i class="fas fa-arrow-right"></i>تماس با ما</router-link
            >
            <router-link class="base-btn-2 why-we__btn" to="/product"
              ><i class="fas fa-arrow-right"></i>مشاهده محصولات</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      showHexagon: false,
      textH1: "چرا محصولات نیش و نوش ؟",
      paraText:
        "تمام محصولات نیش و نوش شامل گارانتی بازگشت وجه می باشد. از آنجایی که ما فقط عسل طبیعی عرضه می کنیم، به طبیعی بودن و خالص بودن عسل هایمان اطمینان کامل داریم. ما می خواهیم این عسل به دست افرادی برسد که خواهان عسل طبیعی هستند.به همین دلیل علاوه بر آخرین برگه آزمایشگاه مربوط به عسل خریداری شده، ضمانت نامه ۲ برابری نیز خدمت تان ارسال می شود.",
      titleText: null,
      titleTextSpeed: 40,
      count: 0,
      showWhyWeText: false,
      whyWePart1:null,
      whyWePart2:null
    };
  },
  mounted() {
    let vh_whyWePart1=window.innerHeight * 1.6 / 3
    let vh_whyWePart2=window.innerHeight * 2.2 / 3
    this.whyWePart1=this.$refs.whyWePart1
    this.whyWePart2=this.$refs.whyWePart2
    window.addEventListener("scroll", () => {
      let topOfwhyWePart1 = this.whyWePart1.getBoundingClientRect().top;
      let topOfwhyWePart2 = this.whyWePart2.getBoundingClientRect().top;
      if (topOfwhyWePart1 < vh_whyWePart1) {
        this.showHexagon = true;
      }
      if (topOfwhyWePart2 < vh_whyWePart2) {
        this.count++;
        if (this.count === 1) {
          this.titleRun();
          setTimeout(() => {
            this.showWhyWeText = true;
          }, 1100);
        }
      }
    });
  },
  methods: {
    titleRun() {
      let textH1Length = this.textH1.length;
      let textH1Index = 0;
      let titleAnimate = setInterval(() => {
        textH1Index++;
        this.titleText = this.textH1.substring(0, textH1Index);
        if (textH1Index > textH1Length) {
          clearInterval(titleAnimate);
        }
      }, this.titleTextSpeed);
    },
  },
};
</script>

<style></style>
